import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState, IStateDepartment } from 'src/entity/StateEntity';
import DepartmentAdminListPage from 'src/components/views/DepartmentAdmin/DepartmentAdminListPage';

const mapStateToProps = ({
  userState: {isDomestic},
}: IStoreState) => ({
  isDomestic,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateDepartment>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentAdminListPage);


// WEBPACK FOOTER //
// ./src/containers/DepartmentAdminList.ts